// extracted by mini-css-extract-plugin
export default {"thumbs_container":"styles_thumbs_container__sTUW7","thumb":"styles_thumb__QX+TJ"};